import { modelSelectionNavigationItems as navigation } from '../../configurator/ModelSelectionNavigationItems';
import {Characteristic, MapCharacteristicAndValue} from "@/configurator/types";
import {DoorConfiguration} from "@/configurator/DoorConfiguration";
import store from "@/store";


const getDefaultState = () => {
    return {
        modelSelection: [],
        sonderFluchtData: [],
        productMatrix: {
            characteristics: [],
            modelStatus: {
                active: false,
            },
            nrModelsFound: 688,
        },
        navigationItems: navigation,
        hasClickedNextStep: false,
        emptyObj: {
            id: 0,
            code: 'NO_CODE',
            description: 'Database Content missing. Press "Daten löschen"',
            values: [
                {
                    id: 0,
                    value: 'NO_VALUE',
                    description: 'No Value',
                },
            ],
        },
    };
};

const state = getDefaultState();

const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.sonderFluchtData;

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getAppropValue = (characteristicCode: string, context: any) => {
    const characteristic = getCharacteristic(characteristicCode, context.state);
    var getter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
    const registeredCharacteristic = getter(characteristicCode, DoorConfiguration.ModelSelection);
    let valueDefinition;

    if (characteristic.values.length > 1) {
        valueDefinition = characteristic.values.filter((x: any) => x.id !== registeredCharacteristic.value.id)[0];
    } else {
        valueDefinition = characteristic.values[0];
    }

    const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
    return selectedCharacteristic;
};

const getters = {
    getProductMatrix: (s: any) => s.productMatrix,

    getModelSelection: (s: any) => s.modelSelection,

    getProductMatrixValues: (s: any) => s.productMatrix.characteristics,

    getHasClickedNextStep: (s: any) => s.hasClickedNextStep,

    getMatrix: (s: any) => (keyword: any) =>
        s.productMatrix.characteristics.filter((characteristic: any) => characteristic.code === keyword)[0],

    getNavigationItem: (s: any) => (code: any) =>
        s.navigationItems.filter((item: any) => item.name === code)[0],

    getNavigationItems: (s: any) => s.navigationItems,

    getMatrixCharacteristics: (s: any) => s.productMatrix.characteristics,

    getCharacteristic: (s: any) => (code: any) =>
    {
        const filteredCharacteristic = s.productMatrix.characteristics.filter(
            (characteristic: any) => characteristic.code === code)[0];
    
        if (typeof filteredCharacteristic !== 'undefined') {
            return filteredCharacteristic;
        } else {
            return s.emptyObj;
        }
    },
};

const actions = {
    setModelSelection(context: any, payload: any) {
        context.commit('updateModelSelection', payload);
    },
    setProductMatrix(context: any, payload: any) {
        context.commit('updateProductMatrix', payload);
    },
    filterProductMatrix(context: any, payload: any){
        context.commit('filterProductMatrix', payload);
    },
    setHasClickedNextStep(context: any, payload: any) {
        context.commit('updateHasClickedNextStep', payload);
    },
    setNavigationItems(context: any, payload: any) {
        context.commit('updateNavigationItems', payload);
    },
    resetState(context: any) {
        context.commit('resetState');
    },
    checkBoxAddCharacteristic(context: any, characteristicCode: string) {
        const char: Characteristic = getAppropValue(characteristicCode, context);
        context.rootState.configuratorModule.doorConfiguration.Add(DoorConfiguration.ModelSelection, char);
    },
    initModelSelectionModule(context : any, payload : any){
        context.commit('initModelSelectionModule', payload);
    },
    extraFilterCharacteristic(context: any, payload: any) {
        context.commit('extraFilterCharacteristic', payload)
    }
};

const mutations = {
    updateModelSelection(s: any, payload: any) {
        s.modelSelection = payload;
    },

    updateHasClickedNextStep(s: any, payload: any) {
        s.hasClickedNextStep = payload;
    },
    
    updateProductMatrix(s: any, payload: any) {
        s.productMatrix.characteristics = payload.characteristics;
        s.productMatrix.nrModelsFound = payload.numberOfModelsFound;
        let sonderFlucht = payload.characteristics.find((x: any )=> x.code == "KTU_MM_FLUCHT_SONDER")
        if( typeof sonderFlucht !== 'undefined') {
            s.sonderFluchtData = sonderFlucht;
        }
    },
    filterProductMatrix(s: any, payload: any) {
        let lastCharData = s.productMatrix.characteristics.find((f: any) => f.code === payload.characteristic.code)
        let lastCharIndex = payload.data.characteristics.findIndex((f: any) => f.code === payload.characteristic.code)
        payload.data.characteristics[lastCharIndex] = lastCharData

        s.productMatrix.characteristics = payload.data.characteristics;
        s.productMatrix.nrModelsFound = payload.data.numberOfModelsFound;

        let sonderFlucht = payload.data.characteristics.find((x: any )=> x.code == "KTU_MM_FLUCHT_SONDER")
        if( typeof sonderFlucht !== 'undefined') {
            s.sonderFluchtData = sonderFlucht;
        }
    },
    updateNavigationItems(s: any, payload: any) {
        s.navigationItems = payload;
    },
    resetState(s: any) {
        Object.assign(s, getDefaultState());
    },
    initModelSelectionModule(state : any, payload : any)
    {
         state.productMatrix.characteristics = payload.productMatrix.characteristics;
         state.productMatrix.nrModelsFound = payload.productMatrix.nrModelsFound;
         state.navigationItems = payload.navigationItems;
         state.sonderFluchtData = payload.sonderFluchtData;
    },
    extraFilterCharacteristic(s: any, payload: any)
    {
        let findCharacteristic = s.productMatrix.characteristics.find((x: any) => x.code == payload.key);
        for(let i = 0; i< payload.data.length; i++) {
            let index = findCharacteristic.values.map((x: any) => {
                return x.value;
            }).indexOf(payload.data[i]);
            findCharacteristic.values.splice(index, 1);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};